module.exports = __webpack_public_path__ + "img/circulo_banner.adb9015a.jpg";